export class InvoicingResultsDtoModel {
	Results: InvoicingResultDtoModel[];
}

export class InvoicingResultDtoModel {
	RecordId: number;
	RecordName: string;
	Result: string;
	IsSuccessfull: boolean;
}